import { useGetEmployeeMeQuery } from "../api/employee";
import { RoleEnum } from "../enums/RoleEnum";

export const useIsEstablishmentManager = (): boolean | undefined => {
    const { data: getEmployeeMeData } = useGetEmployeeMeQuery({});

    return getEmployeeMeData?.roles.some(
        (role) => role.role === RoleEnum.ESTABLISHMENT_MANAGER,
    );
};
